
// JS Dependencies: Popper, Bootstrap & JQuery
import 'moment';
import "../js/core/popper.min.js";
import "../js/core/bootstrap.min.js";

// Custom JS imports
import '../js/login.js';
import Swal from 'sweetalert2';

// CSS Dependencies: Bootstrap
import '../css/bootstrap.min.css';

// Custom CSS imports
import '../css/fonts.css';
import '../css/atlantis.css';
import '../css/login.css';
import '../css/util.css';



$(document).ready(function () {

    const failedLoginAttempts = 'failedLoginAttempts';

    let failedAttempts = parseInt(localStorage.getItem(failedLoginAttempts)) || 0;

    if ($('.validation-summary-errors').length > 0) {

        failedAttempts++;

        if (failedAttempts >= 5) {


            Swal.fire({
                title: "",
                html: '<p>It looks like you may have forgotten your username or password.  Please contact someone from your team who can help, or email us at <a href= "mailto: support@inside-edge.com"> support@inside-edge.com </a> for assistance.</p>',
                icon: "error"
            });
        }
       
        localStorage.setItem(failedLoginAttempts, failedAttempts);
    }
    else {

        localStorage.setItem(failedLoginAttempts, 0);
    }

});